module.exports = __webpack_public_path__ + "img/Lot10.07454710.jpg";